module.exports = __webpack_public_path__ + "img/razorpay.9bbeda52.jpg";